import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../spacesPlatform/utils/actionParams';
import { ILensActions } from '../types/ILensAction';

export class GetLensActionsRequest extends Request<ISingleIdParams, ILensActions> {
  constructor(id: string) {
    super('getLensActions', { id: id });
  }
}
